import { NgModule } from '@angular/core';
import { DataEngagementApiModule } from '@epicuro-next/data/engagement/engagement-api';
import { ProductDataModule } from '@epicuro-next/data/product';
import {
  ConfigurationModule,
  SCANNER_RULE_ENGINE_FEATURE_NAME,
} from '@epicuro-next/platform/configuration';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ScannerEffects } from './barcode-reader';
import { ScanToBasketEffects } from './basket';
import { ScanToListEffects } from './list';
import { reducers, SCAN_FEATURE_KEY } from './main-reducer';
import { ScannerApiService } from './service/scanner-api.service';

@NgModule({
  imports: [
    DataEngagementApiModule,
    ProductDataModule,
    ConfigurationModule.forFeature(SCANNER_RULE_ENGINE_FEATURE_NAME),
    StoreModule.forFeature(SCAN_FEATURE_KEY, reducers),
    EffectsModule.forFeature([
      ScannerEffects,
      ScanToBasketEffects,
      ScanToListEffects,
    ]),
  ],
  providers: [ScannerApiService],
})
export class ScanStateModule {}
